<!-- Project: GSSC Pilot Front-end   -->
<!-- Filename: AssetLabModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="modal asset-lab-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ this.isProcessing ? 'Datalab Launcher' : 'Open in Datalab' }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div v-if="!isProcessing" class="form-group">
              <label for="datalab-selector">Select running Datalab or click New</label>
              <select
                v-if="validInstances"
                class="custom-select form-control"
                :class="{ 'text-disabled': selectedNotRunning }"
                id="image-selector"
                v-model="selectedInstanceName"
                :disabled="showLoader"
                ref="selector"
              >
                <option v-for="(instance, idx) in validInstancesNames" :value="instance" :key="idx">{{
                  instance
                }}</option>
                <option value="New">New</option>
              </select>
            </div>
            <!-- isProcessing = True, show datalab type, can´t change value -->
            <div v-if="newLabMode" class="form-group">
              <label for="name">Name</label>
              <input
                ref="firstInput"
                v-model="name"
                type="search"
                class="asset-lab-modal__name form-control"
                id="name"
                maxlength="40"
                :disabled="showLoader"
              />
            </div>
            <div v-if="isProcessing" class="form-group">
              <label for="type">Type</label>
              <input v-model="lab" type="search" class="asset-lab-modal__name form-control" id="type" disabled />
            </div>
            <div v-if="newLabMode" class="form-group">
              <label for="description">Description</label>
              <textarea
                v-model="desc"
                type="search"
                class="asset-lab-modal__desc form-control"
                id="description"
                disabled
              />
            </div>
            <div v-if="!isProcessing && newLabMode" class="form-group">
              <label for="image-selector">Datalab type</label>
              <select
                v-if="validImages"
                class="custom-select form-control"
                id="image-selector"
                v-model="selectedLab"
                :disabled="showLoader"
              >
                <option v-for="(image, idx) in validImages" :value="image" :key="idx">{{ image }}</option>
              </select>
            </div>
            <button
              class="asset-lab-modal__save btn btn-primary"
              @click.prevent="openLab(selectedInstanceName)"
              :disabled="showLoader || (selectedNotRunning && !isProcessing)"
            >
              {{ buttonText }}
            </button>
            <div v-if="showLoader" class="loader"></div>
            <div v-if="showAlert" class="alert">{{ alertMessage }}</div>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/lib/api'
import helpers from '@/lib/helpers'

export default {
  name: 'AssetLabModal',
  props: {
    lab: {
      type: String,
      default: '',
    },
    assets: Array,
    // the route query to save
    searchParams: Array,
    // Existing filter props (converted to array!)
    isProcessing: Boolean,
    // id: {
    //   type: Number,
    //   required: false,
    // },
    initName: {
      type: String,
      default: '',
    },
    initDesc: {
      type: String,
      default: '',
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: `Datalab ${this.initName}`,
      desc: this.initDesc,
      showLoader: false,
      showAlert: false,
      alertMessage: '',
      validImages: [],
      validInstances: [],
      validInstancesNames: [],
      selectedLab: '',
      selectedInstanceName: '',
      selectedInstance: {},
      newLabMode: false,
    }
  },
  computed: {
    // Params for analysis services API
    assetsList() {
      const assetsList = this.assets.map((asset) => {
        return {
          'asset-id': asset.id,
          'asset-location': asset.path,
        }
      })
      return this.isProcessing ? [] : assetsList
    },
    assetIdArray() {
      const assetIds = this.assetsList.map((e) => Object.assign({ id: e['asset-id'] }))
      return this.isProcessing ? [] : assetIds
    },
    assetsResourceTypesArrOfObj() {
      return this.assets.map((asset) => Object.assign({ resource_type: asset.resource_type.name }))
    },
    buttonText() {
      return this.newLabMode ? 'Launch' : `Open in selected Datalab: "${this.selectedInstanceName}"`
    },
    selectedNotRunning() {
      console.log('check if selected is Running', this.selectedInstanceName)
      return !(this.selectedInstanceName.includes('- Running') || this.selectedInstanceName === 'New')
    },
    id() {
      this.selectedInstance = this.validInstances.find(
        (instance) => instance.name === this.getNameOfSelected(this.selectedInstanceName)
      )
      return this.selectedInstance.id
    },
  },
  methods: {
    // Get lab URL and open in new window
    async openLab(selectedInstanceName) {
      if (!this.newLabMode) {
        // console.log(selectedInstanceName.split(' - '))
        const response = await this.openInSelectedLab(this.getNameOfSelected(selectedInstanceName))
        return
      }
      this.showLoader = true
      this.showAlert = false

      //Function definition for polling status api
      async function poll(response) {
        let data = await api.pollAssetLabStatus(response.id)
        console.log('status is', data.status, 'so waiting 1s')
        while (data.status != 'Running') {
          await wait(2000)
          data = await api.pollAssetLabStatus(response.id)
          console.log({ data })
        }
        console.log({ data })
        return data
      }
      //wait function that returns a promise
      function wait(ms = 1000) {
        return new Promise((resolve) => {
          // console.log(`waiting ${ms} ms...`)
          setTimeout(resolve, ms)
        })
      }
      const response = await api.createLab(
        !this.isProcessing && this.newLabMode ? this.selectedLab : this.lab,
        this.assetsList,
        this.assetIdArray,
        this.name,
        this.desc,
        this.searchParams,
        this.selectAll
      )

      // console.log('ERROR', { response })

      let data = null
      if (response) {
        //If type if response is string means error message is given
        //"Max number of labs reached"
        if (typeof response === 'string') {
          this.showLoader = false
          this.showAlert = true
          this.alertMessage = response
        } else if (helpers.checkErrMessage(response)) {
          this.showLoader = false
          this.showAlert = true
          this.alertMessage = response.error
        } else {
          data = await poll(response)
        }
      }
      if (data) {
        this.showLoader = false
        // window.open(response.url, response.id)
        this.$emit('lab-ready', response.id, response.url)
        this.$store.dispatch('labsNeedRefresh', {
          value: true,
        })
        $('.asset-lab-modal').modal('hide')
        $('.asset-modal').modal('hide')
        this.clearModal()
      }
    },
    // Function to open assets in already existing selected lab
    async openInSelectedLab(name) {
      this.showLoader = true
      const response = await api.openInLab(
        this.id,
        this.assetsList,
        this.assetIdArray,
        name,
        this.searchParams,
        this.selectAll
      )
      this.showLoader = false
      if (response) {
        // disconnect this check for now
        if (typeof response === 'string') {
          this.showAlert = true
          this.alertMessage = response
        } else if (helpers.checkErrMessage(response)) {
          this.showAlert = true
          this.alertMessage = response.error
        } else {
          this.$emit('lab-ready', this.id, this.selectedInstance.url)
          this.$store.dispatch('labsNeedRefresh', {
            value: true,
          })
          $('.asset-lab-modal').modal('hide')
          $('.asset-modal').modal('hide')
          this.clearModal()
          return response
        }
      }
    },
    clearModal() {
      this.name = ''
      this.desc = ''
      this.alertMessage = ''
      this.showLoader = false
      this.showAlert = false
    },
    updateForm() {
      console.log('UPDATE FORM')
      this.name = `Datalab ${this.initName}`
      this.desc = this.initDesc
      this.selectedInstanceName = this.validInstancesNames.length > 0 ? this.validInstancesNames[0] : 'New'
      console.log('update', this.newLabMode)
    },
    async getValidImagesAndInstances() {
      const response = await api.getValidImagesAndInstances(
        this.assetsList,
        this.searchParams,
        this.selectAll,
        this.assetsResourceTypesArrOfObj
      )
      let toReturn = {}
      console.log('VALIDIMAGES', response)
      if (helpers.checkErrMessage(response)) {
        this.showLoader = false
        this.showAlert = true
        this.alertMessage = response.error
      }
      toReturn.validImages = response.valid_images ? response.valid_images.map((image) => image.name) : []
      toReturn.validInstances = response.valid_instances ? response.valid_instances : []
      this.focusNextTick()
      return toReturn
    },
    focusNextTick() {
      console.log('FOCUS NEXT TICK')
      if (this.newLabMode) {
        this.$nextTick(() => {
          console.log('THE REF', this.$refs.firstInput)
          this.$refs.firstInput ? this.$refs.firstInput.blur() : null
          this.$refs.firstInput ? this.$refs.firstInput.focus() : null
        })
      }
    },
    getNameOfSelected(selectedInstanceName) {
      return selectedInstanceName.split(' - ')[0]
    },
  },
  mounted() {
    this.updateForm()
    $('.asset-lab-modal').on('shown.bs.modal', async () => {
      this.showLoader = true
      this.updateForm()
      const { validImages, validInstances } = await this.getValidImagesAndInstances()
      this.validImages = validImages
      this.validInstances = validInstances //.filter((instance) => instance.status == 'Running')
      this.validInstancesNames = this.validInstances.map((instance) => instance.name + ' - ' + instance.status)
      // console.log('labs', this.validInstances)
      this.selectedInstanceName = this.validInstancesNames.length > 0 ? this.validInstancesNames[0] : 'New'
      this.selectedLab = this.validImages[0]
      this.desc = this.selectedLab
      // in case it is a type "Processing" asset selectedLab is given.
      if (this.assets.length == 1 && this.isProcessing) {
        this.selectedLab = this.assets[0].asset_labs[0].name
        this.desc = this.assets[0].file_format.description
      }
      console.log('this.validimages', this.validImages)
      console.log('assetsList', this.assetsList)
      this.showLoader = false
      this.focusNextTick()
    })
    $('.asset-lab-modal').on('hidden.bs.modal', () => {
      this.validImages = []
    })
  },
  watch: {
    selectedInstanceName(value) {
      // If isProcessing must be a new lab (to create from template)
      this.newLabMode = this.isProcessing ? true : value === 'New' ? true : false
      // console.log(this.id)
      this.focusNextTick()
    },
    selectedLab() {
      if (!this.isProcessing) this.desc = this.selectedLab
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/styles/globals';
.asset-lab-modal {
  &.modal .modal-dialog .modal-content {
    border: none;
    border-radius: $border-radius;
    .modal-header {
      border-radius: $border-radius $border-radius 0 0;
      background: $neutral-space;
    }
    .modal-body {
      form {
        min-height: 200px;
      }
      .text-disabled {
        color: #9a9b9c;
      }
    }
  }

  &__save {
    float: right;
  }
}

// .info-group {
//   .heading {
//     font-size: 1.3rem;
//     font-weight: bold;
//     color: $black-85;
//   }
// }

// Spinner styles
.loader {
  right: 120px;
  bottom: 10px;
  position: absolute;
  float: right;
  //display: inline-block;
  border: 10px solid #e9ecef; /* Light grey */
  border-top: 10px solid $deep-space; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.alert {
  display: inline;
  color: red;
  padding: 0;
}
</style>
